import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  aboutUs: {
    id: `footer_link_about_us`,
  },

  blog: {
    id: `footer_link_memrise_blog`,
  },

  contactUs: {
    id: `footer_link_contact_us`,
  },

  engineeringBlog: {
    id: `footer_link_engineering_blog`,
  },

  faq: {
    id: `footer_link_faq_help`,
  },

  jobs: {
    id: `footer_link_jobs`,
  },

  learnLanguage: {
    id: `footer_link_learn_a_language`,
  },

  mobileApp: {
    id: `footer_link_mobile_app`,
  },

  philosophy: {
    id: `footer_link_philosophy`,
  },

  phrasebooks: {
    id: `footer_link_phrasebooks`,
  },

  plans: {
    id: `footer_link_plans`,
  },

  team: {
    id: `footer_link_team`,
  },
});
